// imports
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  closeRequestToggle,
  requestId,
  requestList,
} from "../../state/atom/request";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Http } from "../../utility/http";
import { apiHeaders } from "../../utility/generic";
import { toaster } from "../../state/atom/toaster";

// Component displaying a close request confirmation.
export const CloseRequest = () => {
  
  // states and hooks
  const reqId = useRecoilValue(requestId);
  const [closeReqToggle, setCloseRequestToggle] =
    useRecoilState(closeRequestToggle);
  const setToasterStatus = useSetRecoilState(toaster);
  const setRequestList = useSetRecoilState(requestList);

  // Handles the user confirmation when the user click on Yes button
  const closeRequest = () => {
    // Payload for API
    const request = {
      requestStatus: "completed",
    };

    // Make the POST request for the hold the request.
    Http.request(
      "patch",
      `${process.env.REACT_APP_API_URL}land-request/${reqId}`,
      request,
      apiHeaders()
    )
      .then((result: any) => {
        setRequestList((preState) => {
          let preRequest = [...preState.data.landRequest];
          const index = preRequest.findIndex((val: any) => val.id === reqId);
          //@ts-ignore
          preRequest[index].status = request.requestStatus;
          return {
            ...preState,
            landRequest: preRequest,
          };
        });

        //Show a success notification to the user
        setToasterStatus({
          status: true,
          title: "Request",
          text: "Land request closed successfully",
        });

        // hide the close request confirmation box.
        setCloseRequestToggle(!closeReqToggle);
      })
      .catch((error: any) => {});
  };

  return (
    <div
      className="modal show"
      style={{ display: "block", position: "initial" }}
    >
      <Modal
        show={closeReqToggle}
        onHide={() => setCloseRequestToggle(!closeReqToggle)}
      >
        <Modal.Header closeButton className="toaster-header ">
          <Modal.Title>Close Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to close this request!</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setCloseRequestToggle(!closeReqToggle)}
          >
            Cancel
          </Button>
          <Button onClick={closeRequest} variant="primary">
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
